import { baseQuery } from '../baseQuery';

export const deleteTechnicianNote = async (id: number) => {
  const { data } = await baseQuery(`technicians/notes/${id}`, {
    type: 'DELETE',
  });

  return data;
};
